export enum Page {
  LOG_IN = '/log-in',
  PDF_GENERATOR = '/pdf-generator',
  DASHBOARD = '/dashboard',
}
